export default {
  '短信设置': '短信设置',
  '返回': '返回',
  '短信模版': '短信模版',
  '查看流水': '查看流水',
  '短信供应商平台': '短信供应商平台',
  '供应商': '供应商',
  '账号': '账号',
  '密码': '密码',
  '取消': '取消',
  '确定': '确定',
  '编辑模板': '编辑模板',
  '保存': '保存',
  '短信模板预览': '短信模板预览',
  '短信模板编辑区': '短信模板编辑区',
  '不同短信供应商对短信字数限制不一，可能存在字数溢出的情况，请酌情规划模板字数': '不同短信供应商对短信字数限制不一，可能存在字数溢出的情况，请酌情规划模板字数',
  '基本信息取值区': '基本信息取值区',
  '点击将标签插入模板，短信会根据标签写入实际数值': '点击将标签插入模板，短信会根据标签写入实际数值',
  '验证码': '验证码',
  '提示': '提示',
  '若模板没有保存，直接返回会丢失已修改的模板哦。确定吗？': '若模板没有保存，直接返回会丢失已修改的模板哦。确定吗？',
  '功能类型': '功能类型',
  '短信类型': '短信类型',
  '短信属性': '短信属性',
  '操作': '操作',
  '全局': '全局',
  '渠道': '渠道',
  '开卡': '开卡',
  '储值卡': '储值卡',
  '消费': '消费',
  '其他': '其他',
  '开卡手机验证码': '开卡手机验证码',
  '开卡成功提醒': '开卡成功提醒',
  '会员储值卡使用验证码': '会员储值卡使用验证码',
  '会员储值卡充值成功提醒': '会员储值卡充值成功提醒',
  '会员储值卡消费成功提醒': '会员储值卡消费成功提醒',
  '会员积分使用验证码': '会员积分使用验证码',
  '会员积分充值成功提醒': '会员积分充值成功提醒',
  '会员积分消费成功提醒': '会员积分消费成功提醒',
  '特殊会员VIP折扣使用': '特殊会员VIP折扣使用',
  '高级折扣权限短信验证码': '高级折扣权限短信验证码',
  '消费成功提醒': '消费成功提醒',
  '定金单下单成功提醒': '定金单下单成功提醒',
  '修改会员手机号成功提醒': '修改会员手机号成功提醒',
  '会员等级变动提醒': '会员等级变动提醒',
  '停用': '停用',
  '启用': '启用',
  '未开通短信服务': '未开通短信服务',
  '请联系信息部门': '请联系信息部门',
  '店铺': '店铺',
  '搜索': '搜索',
  '店铺编号': '店铺编号',
  '店铺名称': '店铺名称',
  '知道了': '知道了',
  '快捷设置': '快捷设置',
  '刷新促销': '刷新促销',
  'Web端使用ERP物流模块': 'Web端使用ERP物流模块',
  '模板内容': '模板内容',
  '模板方案': '模板方案',
  '同步ERP渠道资料': '同步ERP渠道资料',
  '未审核': '未审核',
  '审核中': '审核中',
  '审核通过': '审核通过',
  '审核失败': '审核失败',
  '添加账号': '添加账号',
  '确认删除该短信模板吗？': '确认删除该短信模板吗？',
  '删除': '删除',
  '重命名': '重命名',
  '默认': '默认',
  '国际': '国际',
  '中文': '中文',
  '未配置模板的渠道将按默认模板发送短信': '未配置模板的渠道将按默认模板发送短信',
  '确认切换默认模板吗？': '确认切换默认模板吗？',
  '添加模板': '添加模板',
  '审核状态': '审核状态',
  '添加中文模板': '添加中文模板',
  '添加国际模板': '添加国际模板',
  '申请说明': '申请说明',
  '确认删除该短信签名吗？': '确认删除该短信签名吗？',
  '默认签名': '默认签名',
  '审核备注': '审核备注',
  '签名来源': '签名来源',
  '签名名称': '签名名称',
  '添加短信签名': '添加短信签名',
  '短信签名': '短信签名',
  '请在申请说明中 详细描述您的业务使⽤场景，申请⼯信部备案⽹站的全称或简称请在此处填写域名，长度不超过200个字符': '请在申请说明中 详细描述您的业务使⽤场景，申请⼯信部备案⽹站的全称或简称请在此处填写域名，长度不超过200个字符',
  '请输入签名名称': '请输入签名名称',
  '当前⽀持jpg、png、gif或 jpeg格式的图⽚。': '当前⽀持jpg、png、gif或 jpeg格式的图⽚。',
  '签名的证明⽂件格式，⽀持上传多张图⽚。': '签名的证明⽂件格式，⽀持上传多张图⽚。',
  '图片不超过2M': '图片不超过2M',
  '提交审核': '提交审核',
  '证明文件': '证明文件',
  '短信供应商设置': '短信供应商设置',
  '短信签名未设置': '短信签名未设置',
  '短信将无法发送': '短信将无法发送',
  '同步阿里云短信签名': '同步阿里云短信签名',
  '渠道(批量)选择': '渠道(批量)选择',
  '查询': '查询',
  '渠道编号': '渠道编号',
  '请输入渠道编号': '请输入渠道编号',
  '支持配置小票样式&打印张数、短信模板': '支持配置小票样式&打印张数、短信模板',
  '渠道简称': '渠道简称',
  '请输入渠道简称': '请输入渠道简称',
  '经营模式': '经营模式',
  '经营方式': '经营方式',
  '输入或选择': '输入或选择',
  '公司': '公司',
  '组': '组',
  '国家': '国家',
  '销售类别': '销售类别',
  '渠道配置（已选择': '渠道配置（已选择',
  '复制渠道配置（已选择': '复制渠道配置（已选择',
  '个渠道': '个渠道',
  '单据打印样式': '单据打印样式',
  '单据': '单据',
  '销售单': '销售单',
  '定金单': '定金单',
  '会员充值单': '会员充值单',
  '日结': '日结',
  '交接班': '交接班',
  '本机日收银': '本机日收银',
  '发货单': '发货单',
  '单据打印张数': '单据打印张数',
  '已选择': '已选择',
  '状态': '状态',
  '短信模板': '短信模板',
  '会员等级变动升级提醒': '会员等级变动升级提醒',
  '选择短信模板': '选择短信模板',
  '模版方案': '模版方案',
  '模版内容': '模版内容',
  '阿里云短信签名': '阿里云短信签名',
  '选择短信签名': '选择短信签名',
  '保存成功': '保存成功',
  '打印张数': '打印张数',
  '输入张数': '输入张数',
  '做单打印': '做单打印',
  '店铺联': '店铺联',
  '客户联': '客户联',
  '张数': '张数',
  '不能全部为零': '不能全部为零',
  '请填写完整的张数': '请填写完整的张数',
  '选择样式': '选择样式',
  '简易版': '简易版',
  '简易版支持全部终端': '简易版支持全部终端',
  '类型': '类型',
  '自定义版': '自定义版',
  '样式名称': '样式名称',
  '预览': '预览',
  '自定义版仅支持Webpos优先使用': '自定义版仅支持Webpos优先使用',
  '变更记录': '变更记录',
  '销售单小票': '销售单小票',
  '定金单小票': '定金单小票',
  '充值单': '充值单',
  '请先选择模版': '请先选择模版',
  '再保存': '再保存',
  '充值单据': '充值单据',
  '500条/页': '500条/页',
  '第': '第',
  '页': '页',
  '共': '共',
  '没有可选的数据': '没有可选的数据',
  '渠道配置中心': '渠道配置中心',
  '支持配置小票样式&打印张支持配置小票样式数、短信模板': '',
  '配置说明': '配置说明',
  '配置后，POS需重新登录后生效': '配置后，POS需重新登录后生效',
  '渠道(批量)': '渠道(批量)',
  '请输入内容': '请输入内容',
  '选项': '选项',
  '清空': '清空',
  '列表': '列表',
  '编辑': '编辑',
  '户口': '户口',
  '批量配置单据打印样式': '批量配置单据打印样式',
  '批量配置单据打印张数': '批量配置单据打印张数',
  '批量配置短信模板': '批量配置短信模板',
  '复制其他渠道模板': '复制其他渠道模板',
  '会员充值小票': '会员充值小票',
  '日结小票': '日结小票',
  '交接班小票': '交接班小票',
  '本机日收银小票': '本机日收银小票',
  '发货单小票': '发货单小票',
  '做单打印张数 店铺联/客户联': '做单打印张数 店铺联/客户联',
  '重打印张数 店铺联/客户联': '重打印张数 店铺联/客户联',
  '未选择业务属性': '未选择业务属性',
  '请选择渠道': '请选择渠道',
  '同步ERP渠道资料成功！': '同步ERP渠道资料成功！',
  '系统默认模版': '系统默认模版',
  '做单': '做单',
  '企事业单位的全称或简称': '企事业单位的全称或简称',
  '工信部备案网站的全称或简称': '工信部备案网站的全称或简称',
  'APP应用的全称或简称': 'APP应用的全称或简称',
  '公众号或小程序的全称或简称': '公众号或小程序的全称或简称',
  '电商平台店铺名的全称或简称': '电商平台店铺名的全称或简称',
  '商标名的全称或简称': '商标名的全称或简称',
  '请输入签名来源': '请输入签名来源',
  '请输入签名说明': '请输入签名说明',
  '重新上传成功': '重新上传成功',
  '添加成功': '添加成功',
  '上传图片不能大于2M': '上传图片不能大于2M',
  '短信模板数量不能超过10个': '短信模板数量不能超过10个',
  '请输入名称': '请输入名称',
  '保存后': '保存后',
  '模版将提交审核，': '模版将提交审核，',
  '审核通过前短信模版无法使用，确认吗？': '审核通过前短信模版无法使用，确认吗？',
  '已经存在该字段，不可重复添加': '已经存在该字段，不可重复添加',
  '请选择要编辑的模版': '请选择要编辑的模版',
  '保存置灰且点击提示“审核中”“审核通过”模板不可修改': '保存置灰且点击提示“审核中”“审核通过”模板不可修改',
  '删除成功': '删除成功',
  '超过最大字数': '超过最大字数',
  '模版中含有非法取值字段，请先删除再保存': '模版中含有非法取值字段，请先删除再保存',
  '短信模板不能为空！': '短信模板不能为空！',
  '短信模板缺少验证码！': '短信模板缺少验证码！',
  '短信模板保存成功': '短信模板保存成功',
  '重命名成功': '重命名成功',
  '同步阿里云签名': '同步阿里云签名',
  '输入在阿里云后台注册的签名名称，同步至企业管理后台': '输入在阿里云后台注册的签名名称，同步至企业管理后台',
  '签名名称不能为空': '签名名称不能为空',
  '同步签名成功': '同步签名成功',
  '更新默认签名成功': '更新默认签名成功',
  '删除签名成功': '删除签名成功',
  '序': '序',
  '配置': '配置',
  '请勿轻易切换供应商，审核状态将会被重置！': '请勿轻易切换供应商，审核状态将会被重置！',
  '区域': '区域',
  '省份': '省份',
  '渠道性质': '渠道性质',
  '店铺联/顾客联打印张数不能全部为0': '店铺联/顾客联打印张数不能全部为0',
  '销售退款（储值积分返还）提醒': '销售退款（储值积分返还）提醒',
  '渠道调出': '渠道调出',
  '重打印': '重打印',
  '渠道退货': '渠道退货',
  '采购退货': '采购退货',
  '退货通知': '退货通知',
  '是否保存模板？': '是否保存模板？',
  '积分': '积分',
  '线上订单发货': '线上订单发货',
  '渠道调入': '渠道调入',
  '渠道收货': '渠道收货',
  '退货': '退货',
  '紧急发货': '紧急发货',
  '发货': '发货',
  '配单': '配单',
  '验货': '验货',
  '全部': '全部',
  '配置教学': '配置教学',
  '已配置短信渠道': '已配置短信渠道',
  '已开启ERP权限': '已开启ERP权限',
  '未开启ERP权限': '未开启ERP权限',
  '配置了该短信模板且已开通ERP权限的渠道，可正常使用短信功能': '配置了该短信模板且已开通ERP权限的渠道，可正常使用短信功能',
  '配置了该模板但未开通ERP权限的渠道,请前往ERP渠道资料开通权限': '配置了该模板但未开通ERP权限的渠道,请前往ERP渠道资料开通权限',
  '短信配置主要为以下流程': '短信配置主要为以下流程',
  '设置好短信签名，提交供应商审核（部分供应商无需配置签名）': '设置好短信签名，提交供应商审核（部分供应商无需配置签名）',
  '点击短信类型右侧的编辑模板，保存后提交供应商审核': '点击短信类型右侧的编辑模板，保存后提交供应商审核',
  '到': '到',
  '开通渠道': '开通渠道',
  '重新上传': '重新上传',
  '给不同渠道配置对应模板': '给不同渠道配置对应模板',
  '前往ERP渠道资料，开启所有渠道的短信发送权限': '前往ERP渠道资料，开启所有渠道的短信发送权限',
  '请先选择模版再保存': '请先选择模版再保存',
  '全部数据导入成功': '全部数据导入成功',
  '零售方式': '零售方式',
  '积分清零提醒': '积分清零提醒',
  '生日代用券': '生日代用券',
  '短信签名一般为品牌名称，顾客短信可见，必填': '短信签名一般为品牌名称，顾客短信可见，必填',
  '请填写短信签名': '请填写短信签名',
  '若清空供应商，可能会丢失原有短信供应商的模板审核状态，请谨慎操作': '若清空供应商，可能会丢失原有短信供应商的模板审核状态，请谨慎操作。',
  '查询结果': '查询结果',
  '搜索渠道': '搜索渠道',
  '重置': '重置',
  '条': '条',
  '100条/页': '100/行',
  '200条/页': '200/行',
  '300条/页': '300/行',
  '400条/页': '400/行',
  '请输入账号': '请输入账号',
  '输入账号': '输入账号',
  '请输入密码': '请输入密码',
  '输入密码': '输入密码',
  '账号不能为空': '账号不能为空',
  '同步ERP收银员': '同步ERP收银员',
  '使用教程': '使用教程',
  '不记名储值卡余额变动提醒': '不记名储值卡余额变动提醒',
  '不记名储值卡开卡成功提醒': '不记名储值卡开卡成功提醒',
  '不记名卡使用验证': '不记名卡使用验证',
  '打印单据张数': '打印单据张数',
  '打印快递单张数': '打印快递单张数',
  '打印快递单': '打印快递单',
  '打印单据': '打印单据',
  '更新版本': '更新版本',
  '更新版本成功': '更新版本成功',
  '大版本号': '大版本号',
  '忘记密码发送随机密码提醒': '忘记密码发送随机密码提醒',
  '修改密码成功提醒': '修改密码成功提醒',
  'VIP积分兑换货品短信验证': 'VIP积分兑换货品短信验证'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/note.js